import { render, staticRenderFns } from "./Swelling.vue?vue&type=template&id=03c53836&scoped=true"
import script from "./Swelling.vue?vue&type=script&lang=js"
export * from "./Swelling.vue?vue&type=script&lang=js"
import style0 from "./Swelling.vue?vue&type=style&index=0&id=03c53836&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03c53836",
  null
  
)

export default component.exports